import { render, staticRenderFns } from "./balanceChangeRecord.vue?vue&type=template&id=0b5d0337&"
import script from "./balanceChangeRecord.vue?vue&type=script&lang=js&"
export * from "./balanceChangeRecord.vue?vue&type=script&lang=js&"
import style0 from "./balanceChangeRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports